export class ServiceCategoryReferenceModel {
    public serviceCategoryCode: string;
    public serviceCategoryName: string;
    public sortSequence: number;
    public serviceCategoryColor: string;
}